import { Dashboard } from '@unistocks/features/dashboard/dashboard';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function DashboardScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Dashboard')}</title>
      </Head>
      <Dashboard />
    </>
  );
}
